import { socketClient } from '../socketClient'

const listeners = new Set<() => void>();
let installed = false;

const installReconnectDispatcher = () => {
    if (installed) return;
    installed = true;
    const original = socketClient.onConnect;
    socketClient.onConnect = (frame) => {
        original?.(frame);
        listeners.forEach((listener) => listener());
    };
};

export const subscribeWhenConnected = (callback: () => void) => {
    installReconnectDispatcher();
    listeners.add(callback);

    // =====================================================
    // ✅ YA CONECTADO
    // =====================================================

    if (socketClient.connected) {

        callback()
    }

    // =====================================================
    // ⏳ ESPERAR CONEXIÓN
    // =====================================================

    return () => listeners.delete(callback)
}
